export default __webpack_public_path__ + "static/media/profile.fc81fc30.png";